import React, { useState } from 'react';

export default function StarRating({ value = 0, onChange, readonly = false }) {
  const [hover, setHover] = useState(0);

  return (
    <div className="star-rating">
      {[1, 2, 3, 4, 5].map(star => (
        <span
          key={star}
          className={`star ${(hover || value) >= star ? 'filled' : 'empty'}`}
          onClick={() => !readonly && onChange?.(value === star ? 0 : star)}
          onMouseEnter={() => !readonly && setHover(star)}
          onMouseLeave={() => !readonly && setHover(0)}
          style={{ cursor: readonly ? 'default' : 'pointer' }}
        >
          &#9733;
        </span>
      ))}
    </div>
  );
}
